import React from 'react';
import { File, Folder, ChevronRight, ChevronDown } from 'lucide-react';

function FileTree({ files, selectedFile, onSelect }) {
  const buildTree = (filesList) => {
    const tree = {};

    filesList.forEach((file) => {
      const parts = (file.path || '').split('/');
      let current = tree;

      parts.forEach((part, i) => {
        if (!part) return;
        if (i === parts.length - 1) {
          current[part] = file;
        } else {
          if (!current[part]) current[part] = {};
          current = current[part];
        }
      });
    });

    return tree;
  };

  const tree = buildTree(files || []);

  const TreeNode = ({ name, node, level }) => {
    const [expanded, setExpanded] = React.useState(true);
    const isFile = node && typeof node === 'object' && Object.prototype.hasOwnProperty.call(node, 'path');

    if (isFile) {
      return (
        <div
          className={`flex items-center gap-2 px-2 py-1 cursor-pointer hover:bg-gray-700 rounded ${
            selectedFile && selectedFile.path === node.path ? 'bg-gray-700' : ''
          }`}
          style={{ paddingLeft: `${level * 12 + 8}px` }}
          onClick={() => onSelect(node)}
        >
          <File size={16} className="text-gray-400" />
          <span className="text-sm">{name}</span>
        </div>
      );
    }

    return (
      <div>
        <div
          className="flex items-center gap-2 px-2 py-1 cursor-pointer hover:bg-gray-700 rounded"
          style={{ paddingLeft: `${level * 12 + 8}px` }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? (
            <ChevronDown size={16} className="text-gray-400" />
          ) : (
            <ChevronRight size={16} className="text-gray-400" />
          )}
          <Folder size={16} className="text-blue-400" />
          <span className="text-sm font-medium">{name}</span>
        </div>
        {expanded && (
          <div>
            {Object.entries(node || {}).map(([key, value]) => (
              <TreeNode key={key} name={key} node={value} level={level + 1} />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="p-2">
      <div className="mb-2 px-2 py-1 text-xs font-semibold text-gray-400">
        PROJECT FILES
      </div>
      {Object.keys(tree).length > 0 ? (
        Object.entries(tree).map(([key, value]) => (
          <TreeNode key={key} name={key} node={value} level={0} />
        ))
      ) : (
        <div className="text-center text-gray-500 text-sm py-8">
          No files yet. Chat with AI to generate code!
        </div>
      )}
    </div>
  );
}

export default FileTree;
